var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServicosHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2388_5180",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2388_5180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 14V7.34375C1 6.86458 1.16296 6.45312 1.48889 6.10937C1.81481 5.76562 2.21204 5.59375 2.68056 5.59375H8.48611V3.71875C8.48611 3.23958 8.64907 2.83333 8.975 2.5C9.30093 2.16667 9.69815 2 10.1667 2H13.8333C14.3019 2 14.6991 2.16667 15.025 2.5C15.3509 2.83333 15.5139 3.23958 15.5139 3.71875V5.59375H21.3194C21.788 5.59375 22.1852 5.76562 22.5111 6.10937C22.837 6.45312 23 6.86458 23 7.34375V14H14.0167V13.2812C14.0167 13.0312 13.9403 12.8281 13.7875 12.6719C13.6347 12.5156 13.4361 12.4375 13.1917 12.4375H10.8389C10.5944 12.4375 10.3907 12.5156 10.2278 12.6719C10.0648 12.8281 9.98333 13.0312 9.98333 13.2812V14H1ZM9.40278 5.59375H14.5972V3.71875C14.5972 3.53125 14.5157 3.35938 14.3528 3.20313C14.1898 3.04688 14.0167 2.96875 13.8333 2.96875H10.1667C9.98333 2.96875 9.81018 3.04688 9.64722 3.20313C9.48426 3.35938 9.40278 3.53125 9.40278 3.71875V5.59375ZM10.9306 15.5938V13.375H13.1V15.5938H10.9306ZM2.68056 22C2.21204 22 1.81481 21.8229 1.48889 21.4688C1.16296 21.1146 1 20.7083 1 20.25V14.9688H9.98333V15.6875C9.98333 15.9167 10.0699 16.1198 10.2431 16.2969C10.4162 16.474 10.6148 16.5625 10.8389 16.5625H13.1917C13.4361 16.5625 13.6347 16.474 13.7875 16.2969C13.9403 16.1198 14.0167 15.9167 14.0167 15.6875V14.9688H23V20.25C23 20.7083 22.837 21.1146 22.5111 21.4688C22.1852 21.8229 21.788 22 21.3194 22H2.68056Z",
    fill: "#58C5C6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicosHover);
export default __webpack_public_path__ + "static/media/servicos_hover.6a4b2bf54c9b3da7a22e8904266fdca0.svg";
export { ForwardRef as ReactComponent };